export default __webpack_public_path__ + "static/media/bislig-right.19d4b99c.png";